<template>
  <div class="h-screen flex items-center justify-center">
    <div
      class="relative w-full md:w-1/2 h-screen max-w-[900px] md:max-h-[600px] px-6 shadow-xl md:rounded-2xl bg-white overflow-hidden"
    >
      <button
        v-if="step > 2"
        @click="step--"
        class="absolute bottom-0 left-0 bg-black text-white w-20 h-20 rounded-tr-full flex items-center justify-center hover:cursor-pointer"
      >
        <svg
          class="relative -left-2"
          fill="#fff"
          height="32px"
          width="32px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 472.615 472.615"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M167.158,117.315l-0.001-77.375L0,193.619l167.157,153.679v-68.555c200.338,0.004,299.435,153.932,299.435,153.932
			c3.951-19.967,6.023-40.609,6.023-61.736C472.615,196.295,341.8,117.315,167.158,117.315z"
              />
            </g>
          </g>
        </svg>
      </button>
      <transition name="fade">
        <AppIntroduction v-show="step === 1" @step="step++" />
      </transition>
      <transition name="fade">
        <SelectDates v-show="step === 2" @step="getCars" />
      </transition>
      <transition name="fade">
        <div>
          <h1 class="text-base md:text-xl text-center mt-6 font-bold">
            Налични марки автомобили за избрания период {{ start_date }} -
            {{ end_date }}
          </h1>
          <AvailableBrands
            v-show="step === 3"
            :brands="brands"
            @brand-select="selectBrand"
          />
        </div>
      </transition>
      <transition name="fade">
        <AvailableModels
          v-if="step === 4"
          :models="models"
          @send-request="sendRequest"
        />
      </transition>

      <div
        v-show="step === 10"
        :class="{ 'animate-bounce': emailSent, 'opacity-0': !emailSent }"
        class="w-1/2 mt-40 mx-auto bg-green-500 text-white p-4 rounded-md shadow-lg transition-opacity duration-500"
      >
        {{ emailStatus }}
      </div>
    </div>
  </div>
</template>

<script>
import AppIntroduction from "./components/AppIntroduction.vue";
import SelectDates from "./components/SelectDates.vue";
import AvailableBrands from "./components/AvailableBrands.vue";
import AvailableModels from "./components/AvailableModels.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    AppIntroduction,
    SelectDates,
    AvailableBrands,
    AvailableModels,
  },
  data() {
    return {
      step: 1,
      cars: [],
      brands: [],
      selectedBrand: "",
      models: [],
      info: null,
      start_date: "",
      end_date: "",
      emailSent: true,
      emailStatus: "",
    };
  },
  methods: {
    getCars(data) {
      this.brands = data.brands;
      this.cars = data.data;
      this.start_date = data.formattedStartDate;
      this.end_date = data.formattedEndDate;
      this.step++;
    },
    selectBrand(brand) {
      this.selectedBrand = brand;
      this.models = this.cars.filter((car) => car.brand === this.selectedBrand);
      this.step++;
    },
    async sendRequest(info) {
      try {
        await axios.post(
          "https://car-booking-api.g-home.site/api/cars/ask-email",
          {
            car_id: info.car,
            name: info.name,
            phone: info.phone,
            start_date: this.start_date,
            end_date: this.end_date,
          }
        );
        this.step = 10;
        this.emailSent = true;
        this.emailStatus = "Запитването е изпратено успешно!";

        setTimeout(() => {
          this.emailSent = false;
          window.location.reload();
        }, 10000); // Animation duration
      } catch (error) {
        this.emailStatus = "Failed to send email.";
        console.error("Email sending failed:", error);
      }
    },
  },
};
</script>

<style>
html,
body {
  background-color: #2c3e50;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
